import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import storage from '../../../services/stoage.service'
import utils, { getMessage } from '../../../utils'
import { actions } from '../remessapagamento.actions'
import { Button } from 'primereact/button'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { logarAcesso } from '../../../services/api-log-acesso'
import { RemessaPagamentoForm } from './RemessaPagamentoForm'

const mapStateToProps = (state) => {
  const messages = state.crudRemessaPagamentoState.messages
  const record = state.crudRemessaPagamentoState.currentRecord
  const item = state.crudRemessaPagamentoState.item
  const itens = state.crudRemessaPagamentoState.itens || []

  // REFERENTE AO DROPDOWN DE UNIDADES
  let disableUnit = false
  let currentUnit = storage.getUnit()
  if (currentUnit) {
    let unidade = {
      id: currentUnit.oid,
      value: currentUnit.sigla,
    }
    Object.assign(record, { unidades: [unidade] })
    Object.assign(record, { unidade: unidade })
    disableUnit = true
  }

  const currentCompany = storage.getCompany()
  let unidades = []
  let unidadesEmpresa = utils.getListIdValuesUnidadeFromEmpresa(currentCompany)
  unidades = unidades.concat(unidadesEmpresa)

  return {
    currentCompany,
    record,
    item,
    messages,
    unidades,
    disableUnit,
    itens,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    setItem: (prop, value) => dispatch(actions.setItem(prop, value)),
    addItem: (payload) => dispatch(actions.addItem(payload)),
    onClickRemoveItem: (item) => dispatch(actions.onClickRemoveItem(item)),
    gerarRemessa: (data) => dispatch(actions.gerarRemessa(data)),
  }
}

class RemessaPagamentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.hideBtnImportacao = true
    this.state = {
      dadosFavorito: null,
      favorito: 0,
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    logarAcesso().then()
  }

  componentWillUnmount() {}

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  gerar = () => {
    const data = {
      unidade: this.props.record.unidade,
      contaCorrente: this.props.record.contaCorrente,
      dataPagamento: this.props.record.dataPagamento,
      itens: this.props.itens,
    }
    this.props.gerarRemessa(data)
  }

  getCustomButtons = () => {
    return (
      <div className="p-toolbar-group-left">
        <Button
          label={utils.getMessage(this.props.messages, 'remessapagamento.label.gerar')}
          icon="pi pi-check"
          className="p-button-success"
          onClick={this.gerar}
        />
      </div>
    )
  }

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={getMessage(this.props.messages, 'remessapagamento.label.titulo')}
      />
    )
  }

  render() {
    const content = (
      <div>
        <RemessaPagamentoForm
          currentUser={this.props.currentUser}
          messages={this.props.messages}
          changeHandler={this.props.changeHandler}
          record={this.props.record}
          item={this.props.item}
          disableUnit={this.props.disableUnit}
          unidades={this.props.unidades}
          setField={this.props.setField}
          itens={this.props.itens}
          addItem={this.props.addItem}
          setItem={this.props.setItem}
          onClickRemoveItem={this.props.onClickRemoveItem}
        />
      </div>
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RemessaPagamentoFormPageContainer)
